export default __webpack_public_path__ + "static/media/provably-fair-gr.5c3d8f22.svg";